import {
  Button,
  Checkbox,
  Col,
  Form,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Divider,
  Switch,
  Spin,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { Label } from '../../../compnents/widgets/Label'
import styles from './personalSetting.module.css'
import {
  Checks,
  getTemPlateName,
  PreferencesSet,
  Settinglable,
} from '../../../models/personalSetting'
import {
  getAllPersonalPreferences,
  getUserProfileListMessage,
  medicalHistorySaveSettingAsync,
  saveSetting,
} from '../personalDetail/personalDetailSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import { Checks as SettingChecks } from '../../../models/setting'
import _ from 'lodash'
import {
  selectEdition,
  selectTenantCategory,
  selectUserId,
} from '../../../app/applicationSlice'
import { EditableList } from '../../../compnents/list/EditableList'
import { useQuery } from '../../../utils/HttpUtils'
import { selectSettings } from '../../user/setting/settingSlice'

const { Option } = Select

export const MedicalSettings = (props: {
  selectedTab: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const userId = useSelector(selectUserId)

  const hisVersion = useSelector(selectEdition)

  const settings = useSelector(selectSettings)

  const [form] = Form.useForm()

  const query = useQuery()

  const id = query?.get('id')

  const tenantCategory = useSelector(selectTenantCategory)

  const [selectedType, setSelectedType] = useState<string>(hisVersion == 1 ? 'KQBL' : 'TYBL')

  const [checkData, setCheckData] = useState<any>([])

  const [formData, setFormData] = useState<any>([])

  const [submitLoading, setSubmitLoading] = useState(false)

  const [tableLoading, setTableLoading] = useState(false)

  const [functionsFieldConfig, setFunctionsFieldConfig] = useState<any>([])

  const [BLListFiles, setBLListFiles] = useState<any>([]) //病历字段

  const [tyblFlag, setTyblFlag] = useState(false)
  const [zymrblFlag, setZymrblFlag] = useState(false)
  const [kqblFlag, setKqblFlag] = useState(false)

  const isInitialized = useRef(false)

  // 默认需要回填上次就诊病历信息的8个字段key
  const defaultMedicalRecordKeys = [
    'historyOfPresentIllness',
    'pastMedicalHistory',
    'allergen',
    'personalHistory',
    'familyHistory',
    'vaccineHistory',
    'menstrualHistory',
    'maritalHistory',
  ]

  const getShowData = () => {
    setTableLoading(true)
    dispatch(getUserProfileListMessage({ userId: id ? id : userId }))
      .then(unwrapResult)
      .then((c: any) => {
        setCheckData(c?.records || [])

        // 病历字段
        const functionsFieldConfig = c?.functionsFieldConfig
        setFunctionsFieldConfig(functionsFieldConfig?.map((t: any) => {
          const fields = t?.fields?.filter((val: any) => !(val?.isNotModified && !val?.isVisible)) || []
          return { ...t, fields: fields.map((f: any) => ({
            ...f,
            isShowMedicalRecord: f.isShowMedicalRecord !== undefined ? f.isShowMedicalRecord : defaultMedicalRecordKeys?.includes(f.key),
          }))}
        }))
      })
      .finally(() => {
        setTableLoading(false)
      })
  }

  useEffect(() => {
    if (props?.selectedTab == '2') {
      getShowData()
      if (hisVersion == 1) {
        setSelectedType('KQBL')
      } else {
        setSelectedType('TYBL')
      }
    }
  }, [dispatch, props?.selectedTab])

  useEffect(() => {
    if (functionsFieldConfig?.length) {
      const TYBLListFiles = functionsFieldConfig?.filter((t: any) => t?.templateType === 'TYBL')?.[0]?.fields //通用病历
      const KQBLListFiles = functionsFieldConfig?.filter((t: any) => t?.templateType === 'KQBL')?.[0]?.fields //口腔病历
      const MRZYListFiles = functionsFieldConfig?.filter((t: any) => t?.templateType === (tenantCategory == 16 ? 'MRBL' : 'ZYBL'))?.[0]?.fields //盲人中医病历

      if (hisVersion == 1) {
        setBLListFiles(KQBLListFiles)
      } else {
        if (selectedType == 'TYBL') {
          setBLListFiles(TYBLListFiles)
        } else if (selectedType == 'KQBL') {
          setBLListFiles(KQBLListFiles)
        } else {
          setBLListFiles(MRZYListFiles)
        }
      }
    }
  }, [functionsFieldConfig, tenantCategory, selectedType])

  useEffect(() => {
    const tabNum = localStorage.getItem('tabNum')

    const ZdblszValue = checkData?.filter((v: any) => v?.code == '1')?.[0]
      ?.codeName //选择要开通的病历

    const MRBLValue = checkData?.filter((v: any) => v?.code == '6')?.[0]
      ?.codeName //选择一个默认病历

    const temp = ZdblszValue ? ZdblszValue?.split(',')?.filter((v: any) => v == '5' || v == '6')?.map(Number) : [] //开通其他模块

    form.setFieldsValue({
      [Checks.Zdblsz]: ZdblszValue ? ZdblszValue?.split(',').map(Number) : [],//选择要开通的病历

      temp: temp, //开通其他模块

      [Checks.MRBL]: tabNum ? Number(tabNum) : Number(MRBLValue), //选择一个默认病历
    })
  }, [dispatch, checkData])

  useEffect(() => {
    if (checkData?.length) {
      const ZdblszValue = checkData?.filter((v: any) => v?.code == '1')?.[0]?.codeName //选择要开通的病历

      const ZdblszValueList = ZdblszValue ? ZdblszValue?.split(',')?.filter((v: any) => v != '5' && v != '6')?.map(Number) : []

      setFormData(ZdblszValueList)
    }
  }, [checkData])

  useEffect(() => {
    if(hisVersion == 1){
      setSelectedType('KQBL')
      setKqblFlag(true) 
    }
    setTyblFlag(formData?.includes(1))
    setZymrblFlag(formData?.includes(2))
    setKqblFlag(formData?.includes(3))
    if (!isInitialized.current) {
      isInitialized.current = true
      const tabNum = localStorage.getItem('tabNum')
      if (tabNum) {
        const num = Number(tabNum)
        console.log(num, "numnumnum")
        if (num === 1) setSelectedType('TYBL')
        else if (num === 2) setSelectedType(tenantCategory == 16 ? 'MRBL' : 'ZYBL')
        else if (num === 3) setSelectedType('KQBL')
      } else {
        setSelectedType(formData?.includes(1) ? 'TYBL' : formData?.includes(2) ? (tenantCategory == 16 ? 'MRBL' : 'ZYBL') : formData?.includes(3) ? 'KQBL' : 'TYBL')
      }
    }
    //选择要开通的病历 联动
    const MRBL = form.getFieldValue([Checks.MRBL])
    !formData?.some((item: any) => item == MRBL) &&
      form.setFieldsValue({
        [Checks.MRBL]: formData?.[0], //默认病历选择开通的病历(formData)中的第一个
      })
  }, [formData])

  const getAllCheckData = () => {
    dispatch(getAllPersonalPreferences({ userId: id ? id : userId }))
      .then(unwrapResult)
      .then((c: any) => {
        const allPersonalPreferences = JSON.stringify(c)
        localStorage.setItem('allPersonalPreferences', allPersonalPreferences)
      })
  }

  console.log(BLListFiles, "BLListFilesBLListFi")
  return (
    <>
      <div className={styles.medicalSettings}>
        <Form
          style={{ height: '100%' }}
          form={form}
          onFinish={(values) => {
            if (!formData?.length) {
              notification.info({
                message: '请至少选择一个病历',
              })
              return
            }
            if (hisVersion != 1) {
              values[Checks.Zdblsz] = values?.temp
                ? Array.from(
                  new Set([...values[Checks.Zdblsz], ...values.temp])
                )
                : [...values[Checks.Zdblsz]]
            }
            //选择要开通的病历拼接开通其他模块字段并保存
            const pattern = /^[1-9]*$/
            const f =
              values &&
              _.chain(values)
                .pickBy((_, k) => pattern.test(k))
                .mapValues(
                  (v, k) =>
                  ({
                    code: k,
                    codeName: typeof v === 'number' || typeof v === 'string'
                      ? v?.toString()
                      : (v?.length ? v?.join(',') : ''),
                    userId: id ? id : userId,
                  } as Settinglable)
                )
                .values()
                .value()

            const uniqueF = _.uniqBy(f, 'code')

            setSubmitLoading(true)
            // dispatch(saveSetting())
            dispatch(medicalHistorySaveSettingAsync({
              userId: id ? id : userId,
              fieldConfigs: functionsFieldConfig,
              records: uniqueF,
            }))
              .then(unwrapResult)
              .then(() => {
                notification.success({
                  message: '保存成功',
                  duration: 3,
                })
                getShowData()
                getAllCheckData()
                const MRBL = form.getFieldValue([Checks.MRBL])
                localStorage.setItem('tabNum', MRBL)
                const MRts = form.getFieldValue([Checks.MRts])
                localStorage.setItem('tipsCount', MRts ? MRts : 7)
                setSelectedType(selectedType)
              })
              .finally(() => {
                setSubmitLoading(false)
              })
          }}
        >
          <div className={styles.formContent}>
            <Spin spinning={tableLoading} style={{ paddingTop: '200px' }}>
              {/* 口腔版不展示开通模块设置 */}
              {hisVersion == 1 ? <></> : <>
                <Label label='开通模块设置' style={{ fontSize: 17 }} noIcon={true} />
                <Divider dashed style={{ margin: 0, marginBottom: 10 }} />
                <Row style={{ marginLeft: 20 }}>
                  <Form.Item
                    label='选择要开通的病历'
                    name={Checks.Zdblsz}
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <Checkbox.Group
                      onChange={(e) => {
                        setFormData(e?.filter((v) => v != '5' && v != '6')?.sort((a: any, b: any) => a - b))
                        setTableLoading(true)
                        setTimeout(() => {
                          setTableLoading(false)
                        }, 500)
                      }}
                    >
                      {PreferencesSet.map((c) => {
                        return (
                          <Checkbox
                            key={c}
                            value={c}
                          >
                            {getTemPlateName(c, tenantCategory)}
                          </Checkbox>
                        )
                      })}
                    </Checkbox.Group>
                  </Form.Item>
                </Row>
                <Row style={{ marginLeft: 20 }}>
                  <Form.Item
                    label='选择一个默认病历'
                    name={Checks.MRBL}
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <Radio.Group>
                      {formData?.map((c: any) => {
                        return (
                          <Radio key={c} value={c}>
                            {getTemPlateName(c, tenantCategory)}
                          </Radio>
                        )
                      })}
                    </Radio.Group>
                  </Form.Item>
                </Row>
                <Row style={{ marginLeft: 20 }}>
                  <Form.Item
                    label='开通其他模块'
                    name='temp'
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                    }}
                  >
                    <Checkbox.Group>
                      <Checkbox value={5}>手术申请</Checkbox>
                      <Checkbox value={6}>手术文书</Checkbox>
                    </Checkbox.Group>
                  </Form.Item>
                </Row>
              </>}
              {(tyblFlag || zymrblFlag || kqblFlag) ? <>
                <div style={{ width: '85%', overflow: 'hidden' }}>
                  <Label label='病历字段设置' style={{ fontSize: 17 }} noIcon={true} />
                  <Divider dashed style={{ margin: 0, marginBottom: 14 }} />
                  {hisVersion == 1 ? <></> :
                    <>
                      {tyblFlag ?
                        <Button
                          type={selectedType === 'TYBL' ? 'primary' : 'default'}
                          onClick={() => {
                            setSelectedType('TYBL')
                          }}
                          style={{ marginRight: '8px' }}
                        >
                          通用病历
                        </Button> :
                        <></>}
                      {zymrblFlag ?
                        <Button
                          type={selectedType === (tenantCategory == 16 ? 'MRBL' : 'ZYBL') ? 'primary' : 'default'}
                          onClick={() => {
                            setSelectedType(tenantCategory == 16 ? 'MRBL' : 'ZYBL')
                          }}
                          style={{ marginRight: '8px' }}
                        >
                          {tenantCategory == 16 ? '盲人病历' : '中医病历'}
                        </Button> :
                        <></>}
                      {kqblFlag ?
                        <Button
                          type={selectedType === 'KQBL' ? 'primary' : 'default'}
                          onClick={() => {
                            setSelectedType('KQBL')
                          }}
                        >
                          口腔病历
                        </Button> :
                        <></>}
                    </>}
                  <EditableList
                    style={{ marginTop: '10px', paddingLeft: '10px', }}
                    dataSource={BLListFiles}
                    bordered={true}
                    pagination={false}
                    columns={[
                      {
                        title: '序号',
                        key: 'no',
                        align: 'center',
                        width: '5rem',
                        render: (_1, _2, i) => `${i + 1}`,
                      },
                      {
                        title: '病历字段',
                        dataIndex: "label",
                        key: "label",
                        align: "left",
                        width: '24rem',
                      },
                      {
                        title: '是否展示',
                        dataIndex: "isVisible",
                        key: "isVisible",
                        align: "center",
                        width: '12rem',
                        render: function action(_, n: any) {
                          return (
                            <Switch
                              checkedChildren='开启'
                              unCheckedChildren='关闭'
                              checked={n.isVisible}
                              disabled={settings?.[SettingChecks.DZBLCTSD] && selectedType === 'TYBL' ? true : n.isRequired || n.isNotModified}
                              onChange={(checked) => {
                                // 如果必填项已开启或isNotModified为true，则不允许修改
                                if (n.isRequired || n.isNotModified) {
                                  return
                                }
                                const newIsShowMedicalRecord = !checked ? false : n.isShowMedicalRecord
                                const data = functionsFieldConfig?.map((t: any) => {
                                  console.log(t,selectedType,"ttttttt")
                                  return {
                                    ...t,
                                    fields: t?.templateType === selectedType ? t?.fields?.map((c: any) => {
                                      return {
                                        ...c,
                                        isVisible: n?.key === c?.key ? checked : c?.isVisible,
                                        isShowMedicalRecord: n?.key === c?.key ? newIsShowMedicalRecord : c?.isShowMedicalRecord,
                                      }
                                    }) : t?.fields
                                  }
                                })
                                setFunctionsFieldConfig(data)
                              }}
                            />
                          )
                        },
                      },
                      {
                        title: '是否回填上次就诊的病历信息',
                        key: 'isShowMedicalRecord',
                        dataIndex: "isShowMedicalRecord",
                        align: 'center',
                        width: '18rem',
                        render: function action(_, n: any) {
                          return (
                            <Switch
                              checkedChildren='开启'
                              unCheckedChildren='关闭'
                              checked={n.isShowMedicalRecord}
                              disabled={!n.isVisible}
                              onChange={(checked) => {
                                const data = functionsFieldConfig?.map((t: any) => {
                                  return {
                                    ...t,
                                    fields: t?.templateType === selectedType ? t?.fields?.map((c: any) => {
                                      return {
                                        ...c,
                                        isShowMedicalRecord: n?.key === c?.key ? checked : c?.isShowMedicalRecord,
                                      }
                                    }) : t?.fields
                                  }
                                })
                                setFunctionsFieldConfig(data)
                              }}
                            />
                          )
                        },
                      },
                    ]}
                  />
                </div></> :
                <></>}
            </Spin>
          </div>
          <Row style={{ paddingTop: '10px', justifyContent: 'center', }}>
            <Button
              onClick={() => {
                getShowData()
              }}
              style={{
                marginRight: '10px',
              }}
            >
              取消
            </Button>
            <Button
              loading={submitLoading}
              type='primary'
              onClick={() => {
                form.submit()
              }}
            >
              保存
            </Button>
          </Row>
        </Form>
      </div>
    </>
  )
}
